import { render, staticRenderFns } from "./Assignatures.vue?vue&type=template&id=430d5046&scoped=true"
import script from "./Assignatures.vue?vue&type=script&lang=js"
export * from "./Assignatures.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "430d5046",
  null
  
)

export default component.exports